import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Reusable Components
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

// Images

function Block_Section2() {
  const titlesDescriptionsObj = {
    "Regular inspections of common areas": "",
    "Managing service contracts for lifts, security, pest control, and more": "",
    "Preparing and managing service charge budgets and sinking funds": "",
    "Coordinating meetings with owners and management committees": "",
    "Handling legal compliance for communal spaces": "",
    "24/7 emergency response for shared areas": "",
    "Overseeing cleaning, landscaping, and refuse collection": "",
    "Project management for renovations or upgrades": "",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="What’s Included in Our Block Management Services?"
              contents=""
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Block_Section2;
